// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__p4NSG","paramInput":"JobSimulator_paramInput__1S6OG","input":"JobSimulator_input__3YtPW"};